import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6adf3f22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-menu" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sn-border-top" }, null, -1))
const _hoisted_4 = { class: "sn-sub-item" }
const _hoisted_5 = {
  key: 0,
  class: "sn-border-botton"
}

import { TMenuType } from '@/module/database';
import { ref } from 'vue';

type Props = {
    menuList:Array<TMenuType>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    menuList: { default: ()=>[] }
  },
  emits: ['onToRouter'],
  setup(__props: any, { emit }) {

const props = __props as { menuList:Array<TMenuType> }



const defaultMenu = ref(['0'])

const active = ref('0')
const subIndex = ref(0)





const onToRouter = (id:string,i:number)=>{
    subIndex.value = i
    emit("onToRouter",id)
}

const onIndex = (index:string)=>{
    active.value = index
}



return (_ctx: any,_cache: any) => {
  const _component_OfficeBuilding = _resolveComponent("OfficeBuilding")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_submenu = _resolveComponent("el-submenu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "default-active": active.value,
      class: "el-menu-vertical-demo",
      "unique-opened": true,
      "default-openeds": ['1']
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.Id,
            class: "sn-menu-wrap"
          }, [
            _createVNode(_component_el_submenu, {
              index: item.Id+''
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(['sn-menu-title', { 'sn-menu_active': index === Number.parseInt(active.value) }]),
                  onClick: ($event: any) => (onIndex(index.toString()))
                }, [
                  _createVNode(_component_el_icon, { class: "sn-menu-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_OfficeBuilding)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(item.Name), 1)
                ], 10, _hoisted_2)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item_group, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Children, (child, i) => {
                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                        class: _normalizeClass({subActive:i===subIndex.value}),
                        index: child.Id+'',
                        onClick: ($event: any) => (onToRouter(child.Id.toString(),i))
                      }, {
                        title: _withCtx(() => [
                          _hoisted_3,
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_el_icon, { class: "sn-menu-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Document)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("span", null, _toDisplayString(child.Name), 1)
                          ]),
                          (!(child.Children?.length === i))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["class", "index", "onClick"]))
                    }), 256))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["index"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}
}

})